import { Box, Button, Grid, ListItemSecondaryAction, Stack, Typography } from "@mui/material";
import List from '@mui/material/List';
import React from "react";
import Avatar from '@mui/material/Avatar';
import MainCard from "ui-component/cards/MainCard";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import OTPInput from "./Components/UserRole/OtpInput";
import { useState } from "react";
import { useNavigate } from "react-router";
import SnackBar from "./Components/General/SnackBar";
import BackdropLoader from "./Components/General/Loader";
import { ResendOtpNew, SsoVerify, VerifyLoginNew } from "API/Authentication/api";
import { useEffect } from "react";
import Divider from '@mui/material/Divider';
import "./CSS/UserRole.css"
import { FaCheckCircle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";



const divstyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // padding: "10px" 
    //  // adjust padding as needed
    borderRadius: "20px"
}

const roles = {
    "tm": "Territory Manager",
    "sh": "State Head",
    "ops": "Operations",
    "rm": "Regional Manager",
    "cso": "CSO",
    "ds": "Distributor",
    "fh": "Finance Head",
    "ft": "Field Technical",
    "pa": "Procurement Admin",
    "aec_admin":"AEC Admin"
}

const UserRoles = (props) => {
    const [Otp, setOtp] = useState("")
    const [SelectedIndex, setSelectedIndex] = useState(0)
    const [Count, setCount] = useState(120)
    const Nav = useNavigate()
    // const location = useLocation()

    const listColor = ["#592375", "#8BAA29", "#FFAB00"]

    useEffect(() => {
        setCount(120)
    }, [])

    useEffect(() => {
        if (Count > 0) {
            const timer = setTimeout(() => {
                setCount(Count - 1);
            }, 1000);
            return () => clearTimeout(timer); // Cleanup function to avoid memory leaks
        }
    }, [Count]);

    const [alertMessage, setAlertMessage] = useState("")
    const [alertType, setAlertType] = useState("")
    const [openAlert, setOpenAlert] = useState(false)

    const [IsLoading, setIsLoading] = useState(false)

    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)
    }

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    // console.log("location",location);

    const handleSubmit = () => {
        if (props.data && props.data.type === 'general') {
            if (!Otp || Otp.length !== 6) {
                handleAlertOpen("Please enter a valid otp", "error")
                return
            }
            else if (!props.data.data.available_roles[SelectedIndex]) {
                handleAlertOpen("Please select a role", "error")
                return
            }
            else {
                console.log("otp", Otp.length);

                let data = {
                    "user_id": props.data.data.user_id,
                    "user_type": props.data.data.available_roles[SelectedIndex],
                    "otp": Otp,
                    "usercode": props.data.mobile
                }

                // console.log("data",data);

                VerifyLoginNew(data, handleAlertOpen, setIsLoading, Nav, setOtp)

            }
        }
        else {
            let data = {
                "user_id": props.data.data.user_id,
                "user_type": props.data.data.available_roles[SelectedIndex],
            }

            SsoVerify(data, setIsLoading, handleAlertOpen)
        }

    }

    useEffect(() => {
        if (props.data && props.data.type !== 'general' && props.data.data.available_roles.length === 1) {
            setSelectedIndex(0)
            handleSubmit()
        }
    }, [])

    const handleResendOtp = () => {
        const data = { mobile_no: props.data.mobile, password: props.data.password }
        ResendOtpNew(data, handleAlertOpen, setIsLoading, setCount)
    }

    return (
        // props.data && props.data.data && props.data.data.user_id ?
        <div style={divstyle}>
            <BackdropLoader open={IsLoading} />
            <SnackBar open={openAlert} type={alertType} message={alertMessage} handleClose={handleAlertClose} />
            <Grid container justifyContent="center">
                <Grid item xs={12}>

                    <MainCard sx={{ borderRadius: "20px", border: "1px solid #D0D0D0 !important" }}>
                        <Box sx={{position:"relative",cursor:"pointer"}} onClick={()=>props.setActivePage(0)}>
                            <Box sx={{ position: "absolute", top: "0px", right: "-20px", transform: "translate(-50%, -50%)" ,fontSize:"22px"}}>
                                <IoIosCloseCircle />
                            </Box>
                        </Box>

                        <Grid container justifyContent="center" padding={1}>
                            <Grid item md={12}>
                                <Stack sx={{ height: "100%" }} alignItems="flex-start">
                                    <Typography variant="h5" fontSize="24px" color="#000">
                                        Sign In to your Account
                                    </Typography>
                                    {

                                        props.data && props.data.type === "general" ?
                                            <Typography className="poppins-medium" variant="h5" fontSize="14px" color="#64748B" mt={1}>
                                                We’ve sent 6 digits verification code to the registered mobile number.
                                            </Typography> :
                                            null
                                    }


                                    {
                                        props.data && props.data.type === "general" ?
                                            <Typography variant="h6" fontSize="14px" className="poppins-medium" color="#26557E" mt={1}>
                                                Enter the received OTP and select a user role to Proceed.
                                            </Typography>
                                            :
                                            <Typography variant="h6" fontSize="14px" className="poppins-medium" color="#26557E" mt={1}>
                                                Select a user role to <span style={{ color: "#688B2A" }}>proceed.</span>
                                            </Typography>
                                    }

                                    {
                                        props.data && props.data.type === "general" ?

                                            <Typography variant="h5" fontSize="15px" className="poppins-medium" color="#000" mt={2}>
                                                Verification Code
                                            </Typography>
                                            :
                                            null
                                    }

                                    {
                                        props.data && props.data.type === "general" ?
                                            <Stack width="100%" alignItems="center" mt={2}>
                                                <OTPInput otp={Otp} setOtp={setOtp} />
                                            </Stack>
                                            :
                                            null
                                    }


                                    {
                                        props.data && props.data.type === "general" ?
                                            Count > 0 ?
                                                <Typography width="100%" textAlign="center" variant="h6" mt={1}>Resend otp in {Count} seconds</Typography>
                                                :
                                                <Stack width="100%" alignItems="center">
                                                    <Button variant="text" sx={{ backgroundColor: "none", color: "#688B2A" }} onClick={() => handleResendOtp()} mt={1}>Resend otp</Button>
                                                </Stack>
                                            :
                                            null
                                    }

                                </Stack>
                            </Grid>

                            <Grid item xs={12} mt={2}>
                                <Divider />
                            </Grid>


                            <Grid item xs={12} marginTop={2} alignItems="center" justifyContent="center">
                                <Typography className="poppins-semibold">Select Role</Typography>
                            </Grid>


                            {/* Right Side: Role Selection Buttons */}
                            <Grid item xs={12} height="100%">
                                <Stack sx={{ height: "100%", width: "100%" }} padding={0} justifyContent="space-between">


                                    <List sx={{ paddingBlock: 2, paddingInline: 2, border: "1px solid #E7E6E6", borderRadius: "10px", marginBlock: 2, width: "100%" }}>
                                        {
                                            props.data && props.data.data.available_roles.map((role, index) => (
                                                <ListItemButton sx={{
                                                    borderRadius: "10px", backgroundColor: index === SelectedIndex ? "#AB90B9 !important" : "transparent", color: index === SelectedIndex ? "#fff !important" : "#000", '&:hover': { bgcolor: "transparent" }, '&.Mui-selected': {
                                                        backgroundColor: "#AB90B9", // Background color when selected
                                                        color: "#fff", // Text color when selected
                                                    },
                                                    '& .MuiListItemText-primary': {
                                                        color: index === SelectedIndex ? "#fff !important" : "#000", // Explicitly targeting the text
                                                    },
                                                    width:"100%"
                                                }} key={index} selected={index === SelectedIndex} onClick={() => setSelectedIndex(index)

                                                }>
                                                    <ListItemIcon sx={{ mr: 1 }}>
                                                        <Avatar sx={{ bgcolor: listColor[index % 3], color: "#fff", fontSize: "16px" }}>{role ? role.toUpperCase() : ""}</Avatar>
                                                    </ListItemIcon>
                                                    <ListItemSecondaryAction sx={{ color: "#fff" }}>
                                                        <ListItemIcon sx={{ color: "#fff", fontSize: "20px" }}>
                                                            {index === SelectedIndex ? <FaCheckCircle style={{ color: "#fff" }} /> : null}
                                                        </ListItemIcon>
                                                    </ListItemSecondaryAction>
                                                    <ListItemText
                                                        primaryTypographyProps={{ sx: { fontSize: "14px", fontWeight: 400 } }}
                                                        primary={roles[role] ? roles[role] : role} />
                                                </ListItemButton>))
                                        }
                                    </List>


                                    <Button size="large" variant="contained" sx={{ backgroundColor: "#2563EB", color: "#fff", borderRadius: "12px" }}
                                        onClick={() => handleSubmit()}>Submit</Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </MainCard>
                </Grid>
            </Grid>
        </div>
        // :
        // window.location.href = "/"

    )
}

export default UserRoles;